import React from "react";
import CommonDrawer from "src/components/CommonDrawer/CommonDrawer";
import { useTheme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { useStyles } from "../style";
import DrawerFiles from "./DrawerFiles";

export interface IProps {
  isDrawerOpen: boolean;
  handleCloseDrawer: any;
}
interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={1} style={{ marginTop: "10px" }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function Drawer(props: IProps) {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  const closeDrawer = () => {
    props.handleCloseDrawer();
  };

  return (
    <>
      <CommonDrawer
        heading="Existing Files"
        isOpen={props.isDrawerOpen}
        closeDrawer={() => {
          setValue(0);
          props.handleCloseDrawer();
        }}
        drawerWidth={450}
        border={true}
      >
        <div className={classes.mainDrawer}>
          <AppBar position="static" color="default">
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              aria-label="full width tabs example"
              className={classes.DrawerTabs}
            >
              <Tab label="Select Files" {...a11yProps(0)} />
            </Tabs>
          </AppBar>

          <TabPanel value={value} index={0} dir={theme.direction}>
            <DrawerFiles
              closeDrawer={() => {
                closeDrawer();
              }}
            />
          </TabPanel>
        </div>
      </CommonDrawer>
    </>
  );
}
